import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardViewInvoiceRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardInvoiceViewPageContainerLoadable } from './OrgDashboardInvoiceViewPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardViewInvoiceRoute>,
) {
  await OrgDashboardInvoiceViewPageContainerLoadable.load();
}

export default function OrgDashboardViewInvoiceHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardInvoiceViewPageContainerLoadable />;
}
